<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import { getCookie } from "@/assets/utils/cookie";
import { MessengerJs } from "./android/messager";
let messengerJs = new MessengerJs();
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";

export default {
  name: "App",
  components: {},
  data() {
    return {};
  },

  async created() {
    this.reFreshToken();
    window.htmlApp = messengerJs;
    this.$store.commit("setMessager", messengerJs);
    let finger =
      localStorage.getItem("fingerPrint") || (await getFingerprint());
    localStorage.setItem("fingerPrint", finger);
    localStorage.setItem("channel", "boluoh5");
    this.resetFontSize();
  },
  mounted() {},
  methods: {
    resetFontSize() {
      if (
        typeof window.WeixinJSBridge === "object" &&
        typeof window.WeixinJSBridge.invoke === "function"
      ) {
        handleFontSize();
      } else {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
      }

      function handleFontSize() {
        // 设置网页字体为默认大小
        window.WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
        // 重写设置网页字体大小的事件
        window.WeixinJSBridge.on("menu:setfont", function () {
          window.WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
        });
      }
    },
    //刷新 token
    reFreshToken() {
      this.userToken = getCookie("userToken");
      this.deviceToken = getCookie("deviceToken");
      this.sign = getCookie("sign");
      this.clientIp = getCookie("clientIp");
      this.encryptType = getCookie("encryptType");
      localStorage.setItem("userToken", this.userToken);
      localStorage.setItem("deviceToken", this.deviceToken);
      localStorage.setItem("sign", this.sign);
      localStorage.setItem("clientIp", this.clientIp);
      localStorage.setItem("encryptType", this.encryptType);
    }
  }
};
</script>
